import axiosIns from 'utils/axios'
let epmcore = 'EPM-CORE-SERVICE'


// 获取项目id获取版本
export function getVersionByProjectId (id) {
  return axiosIns({
    url: `/api/pc/projectVersion/get/${id}`,
    owner: epmcore,
    method: 'get'
  })
}

// 项目版本分页
export function getVersionPage (params) {
  return axiosIns({
    url: `/api/pc/projectVersion/page`,
    owner: epmcore,
    method: 'get',
    params
  })
}

export function getVersionDetail (id) {
  return axiosIns({
    url: `/api/pc/projectVersion/getDetail/${id}`,
    owner: epmcore,
    method: 'get'
  })
}



// 更新版本
export function updateVersion (data) {
  return axiosIns({
    url: `/api/pc/projectVersion/update`,
    owner: epmcore,
    method: 'put',
    data: data
  })
}
// 新增版本
export function addVersion (data) {
  return axiosIns({
    url: `/api/pc/projectVersion/add`,
    owner: epmcore,
    method: 'post',
    data: data
  })
}
// 删除版本
export function removeVersionById (id) {
  return axiosIns({
    url: `/api/pc/projectVersion/delete/${id}`,
    owner: epmcore,
    method: 'delete'
  })
}
// 获取版本岗位
export function getCompanyDictByCode (dictGroupCode) {
  return axiosIns({
    url: `/api/pc/companyDict/page`,
    owner: epmcore,
    method: 'get',
    params: dictGroupCode
  })
}

// 更新版本状态
export function updateVersionStage (data) {
  return axiosIns({
    url: `/api/pc/projectVersion/updateStage`,
    owner: epmcore,
    method: 'put',
    data: data
  })
}

export function getStatisticsProjectVersionPartData(params) {
  return axiosIns({
      url:`/api/pc/statistics/getStatisticsProjectVersionPartData`,
      owner: epmcore,
      method: 'get',
      params: params
  })
}


// WEBPACK FOOTER //
// ./src/views/project-manage/version/versionAPI.js